import { environment } from '@env';
import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  issuer: 'https://sodexo-dgtnef.us1.zitadel.cloud',
  clientId: '289665258539315875',
  responseType: 'code',
  oidc: true,
  redirectUri: window.location.origin + '/al/board',
  postLogoutRedirectUri: window.location.origin + '/signedout',
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  scope: 'openid email profile offline_access urn:zitadel:iam:user:resourceowner', // Ask offline_access to support refresh token refreshes
  useSilentRefresh: true, // Needed for Code Flow to suggest using iframe-based refreshes
  sessionChecksEnabled: true,
  showDebugInformation: true, // Also requires enabling "Verbose" level in devtools
  clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
  requireHttps: false,
};

